import { createSelector } from 'reselect'

import { pendingSelector } from 'api/selectors'
import { createDenormalizedSelector } from 'entities/selectors'
import { newsSchema, categorySchema } from 'wordpress/schemas'

const categorySlugSelector = (state, props) => props.match.params.category
export const newsItemSlugSelector = (state, props) => props.match.params.slug

const stateSelector = state => state.news

/* Categories */

const normalizedCategoriesSelector = createSelector(stateSelector, state => state.categories)
export const categoriesSelector = createDenormalizedSelector(normalizedCategoriesSelector, [categorySchema])
export const categorySelector = createDenormalizedSelector(categorySlugSelector, categorySchema)

/* News items */

const newsListStateSelector = createSelector(stateSelector, state => state.newsList)
const normalizedNewsSelector = createSelector(newsListStateSelector, state => state.posts)
export const newsSelector = createDenormalizedSelector(normalizedNewsSelector, [newsSchema])
export const pagingSelector = createSelector(newsListStateSelector, state => state.paging)

/* Single news item */

export const newsItemSelector = createDenormalizedSelector(newsItemSlugSelector, newsSchema)

/* Related news */

export const relatedNewsSelector = createSelector(newsSelector, newsItemSelector, (news, newsItem) =>
    news.filter(item => newsItem && item.id !== newsItem.id)
)

/* Misc */

export const loadingSelector = createSelector(
    pendingSelector,
    pending => pending.categories === true || pending.news === true
)

export const titleSelector = createSelector(newsItemSelector, categorySelector, (newsItem, category) =>
    newsItem ? newsItem.title : category ? category.name : null
)

/* Background image */

const newsItemBackgroundSelector = createSelector(newsItemSelector, newsItemSlugSelector, (newsItem, slug) =>
    newsItem && slug && newsItem.background ? newsItem.background : null
)

const categoryBackgroundSelector = createSelector(categorySelector, categoriesSelector, (category, categories) =>
    category && category.background
        ? category.background
        : (
              Object.values(categories)
                  .filter(category => category.background)
                  .shift() || {}
          ).background
)

export const backgroundImageSelector = createSelector(
    newsItemBackgroundSelector,
    categoryBackgroundSelector,
    (newsItemBackground, categoryBackground) => newsItemBackground || categoryBackground
)
